export default [
  {
    id: 'fire-wheels',
    title: 'Circus of Suns',
    image: '/assets/images/THUMBS/qFirewheelsT.jpg',
    category: 'Bed Quilts',
    details: "My initial idea with this pattern was to combine two strips of ombre cloth in such a way as to make a spiral shape. Above is the latest incarnation of this pattern, and below left is a detail of part of it. The fabric I've used for the lattice is worth explaining: I dyed an ombre, and sprinkled salt on the still-damp fabric, and left it flat on my table to dry. Wonderful things happen!",
    variations: [
      {
        title: 'Fire Wheels',
        image: '/assets/images/bedquilts/Firewheels.jpg',
      },
      {
        title: 'Fire Wheels - detail',
        image: '/assets/images/bedquilts/FirewheelsDet.jpg',
      },
      {
        title: 'Circus of Suns',
        image: '/assets/images/bedquilts/CircusOfSuns.jpg',
        description: 'A much earlier version, called Circus of Suns. Traditional quilt appreciators may notice that the piecing of the large diamonds is the log cabin pattern.',
      },
      {
        title: 'On Display',
        image: '/assets/images/bedquilts/HarlOnMoms.jpg',
        description: 'Another version shown on a bed.'
      }
    ]
  },
  {
    id: 'terrace',
    title: 'Terrace',
    image: '/assets/images/THUMBS/qTerraceT.jpg',
    category: 'Bed Quilts',
    details: <div>
      One day I was dyeing a piece of cloth with a method I've used many times: I lay a large wet white cloth on my dyeing table, then pour the dyes directly on the cloth and blend them so each color fades smoothly into the next. Usually, I carefully hang the piece to dry to minimize further bleeding. 
<br /><br />
On this particular day (for who knows what reason) I wadded up the fabric and dumped it in a pail to dry. The resulting mottled coloring inspired this simple design - a pattern of rectangles, arranged like bricks on a terrace. 
</div>,
    variations: [
      {
        title: 'Purple Terrace - detail',
        image: '/assets/images/bedquilts/PurTerrDet.jpg',
        description: 'A detail view of Purple Terrace, another version of this pattern'
      }
    ]
  },
  {
    id: 'floating-diamonds',
    title: 'Floating Diamonds',
    image: '/assets/images/THUMBS/qAwashT.jpg',
    category: 'Bed Quilts',
    details: <div>
      On this page, you'll see quilts of a pattern I've always called Floating Diamonds. It's reallly the first pattern I developed specifically for my hand-dyed ombre cloth. If you know anything about traditional quilting patterns, you might call it Flying Geese, but after all, what I've used in the design is triangles, squares, and rectangles, which are pretty generic. I cut the ombre cloth into squares, and then triangles, and then keeping things in the proper order, I end up with diamonds that appear to have two sets of colors moving across, or through, each other. Over the years I've made more than 2 dozen quilts of this pattern, and each has a character all its own.
      </div>,
    variations: [
      {title: 'Tiger Tiger',
        image: '/assets/images/bedquilts/TigerTiger.jpg',
      },
      {
        title: 'Alex\'s Flip',
        image: '/assets/images/bedquilts/AlexsFlip.JPG',
        description: 'Above is a picture of the very first quilt I made with my hand-dyed fabric.',
      },
      {
        title: 'Smoke and Mirrors',
        image: '/assets/images/bedquilts/fdsm.jpg',
        description: 'For the next quilt using my ombre cloth, I turned the squares on end, turning them into diamonds, and added a lattice and smaller diamonds.',
      },
      {
        title: 'Awash',
        image: '/assets/images/bedquilts/Awash.jpg',
      },
      {
        title: 'Earth\'s Riches',
        image: '/assets/images/bedquilts/EarthRichesDet.jpg',
      },
      {
        image: '/assets/images/bedquilts/qFlD.jpg'
      },
      {
        image: '/assets/images/bedquilts/qFlDdet.jpg'
      },
    ]
  },
  {
    id: 'strip-scrap',
    title: 'Strip Scrap',
    image: '/assets/images/THUMBS/qRhythmT.jpg',
    category: 'Bed Quilts',
    details: <div>
      One day, I was digging my way through the ever-expanding scrap pile in my studio, and I decided to figure out a way to use all those scraps. My basic plan was to take anything that could be called a strip, and sew it to all the other strips I had in the pile, and then sew the resulting longer strips together. 
      <br /><br />
I make no aesthetic decisions about what should be next to what, but instead use the width of the strips as the only criteria for placement. When I have amassed very long groups of strips (up to 50 yards long), I sew one group to another, side by side. Again, I make no decisions about color or shape. When I've created groups of strips that are 8-12" wide, I cut them to the length I want for the quilt, and arrange them on the wall. Because all the pieces start out as scraps they often get wider or narrower, which makes for some interesting and slightly challenging piecing.
    </div>,
    variations: [
      {
        title: 'Rhythm',
        image: '/assets/images/bedquilts/Rhythm.jpg',
      },
      {
        title: 'City Lights',
        image: '/assets/images/bedquilts/qCityLights.jpg',
      },
      {
        image: '/assets/images/bedquilts/qStr-Scr.jpg'
      },
      {
        image: '/assets/images/bedquilts/qStripScrapDet.jpg'
      },
      {
        image: '/assets/images/bedquilts/qStrScrDetail.jpg'
      }
    ]
  },
  {
    id: 'pelagia-colorata',
    title: 'Pelagia Colorata',
    image: '/assets/images/THUMBS/qPelagiaT.jpg',
    category: 'Bed Quilts',
    details: <div>
      This quilt was created for a woman who saw my work on the web, and wanted a bedquilt related to Mercury, but of a specific size. To follow the process, click here. (You'll also find out why this quilt is named after a jellyfish!)
    </div>,
    variations: [
      {
        title: 'Pelagia Colorata',
        image: '/assets/images/bedquilts/Pelagia600.jpg',
      }
    ]
  },
  {
    id: 'water-zig-zag',
    title: 'Water Zig Zag',
    image: '/assets/images/THUMBS/qMistRisingT.jpg',
    category: 'Bed Quilts',
    variations: [
      {
        title: 'Mist Rising',
        image: '/assets/images/bedquilts/MistRising.jpg',
        description: <div>
          	All the colors in the center of this quilt come from two large pieces of cloth, dyed in an ombre pattern (see below for an explanation). As I do the cutting and piecing, I keep my wits about me to preserve the pieces in their original order. Thus, the colors appear to flow from one piece to the next, creating an illusion of complexity, when in fact the piecing is quite simple.
          <br /><br />
          The border fabric is a bit idiosyncratic, dyed outside on a very hot, sunny day in Vermont. I used thickened black dye (I felt like I was working with used motor oil) after I had sort-of pleated the fabric. I then sprinkled the mess with rock salt, and left it on the table in the sun for several hours.
        </div>
      },
      {
        title: 'Mist Rising - detail',
        image: '/assets/images/bedquilts/MistRisingDet.jpg',
      },
      {
        title: 'Fire on the Lake',
        image: '/assets/images/bedquilts/FireOnTheLake.jpg',
        description: <div>
          And here's another example of the same idea. For this quilt, I dye two 3-yard pieces of cloth in the following manner: I wet the cloth, and spread it on a large table outside. I mix several colors of dye, pour them directly on the cloth, and smoothly blend adjacent colors together. When I've finished dyeing, I very carefully hang the piece of fabric up to dry. The resulting ombre cloth has a multitude of different hues and shades. 
          <br /><br />
The piecing pattern I've created is fairly sharp (with all those points!), but the blending of colors gives the piece a softness. I've done the design over a dozen times, and it's always a completely different quilt because of the mood and interaction of the colors and their placement.
        </div>
      }
    ]
  },
  {
    id: 'maypole',
    title: 'Maypole',
    image: '/assets/images/bedquilts/Maypole.jpg',
    category: 'Bed Quilts',
    variations: [
      {
        title: 'Maypole',
        image: '/assets/images/bedquilts/Maypole.jpg',
        description: <div>Here's yet another way I've combined pieces of ombre fabric. Each of the "ribbons" in the Maypole is made of long skinny triangles that were all cut from ombre fabrics. For this quilt, I cut many many pieces, and then arrange them on my flannel wall.</div>
      }
    ]
  },
  {
    id: 'reef',
    title: 'Reef',
    image: '/assets/images/THUMBS/qReefT.jpg',
    category: 'Bed Quilts',
    details: <div>The center of each quilt is made entirely of pieces of one shape and size. When working on this pattern, I cut out hundreds of equlateral triangles and stick them up on the flannel-covered wall in my studio, allowing me to get some perspective on how the colors interact. A design like this can stay up on my wall for a week or more as I do other work. Occasionally I'll change a piece here and there until I'm satisfied. Then I simply sew all the pieces together!</div>,
    variations: [
      {
        title: 'Peter\'s Reef',
        image: '/assets/images/bedquilts/PetersReef.jpg',
      },
      {
        title: "Reef - detail",
        image: '/assets/images/bedquilts/Reef.jpg',
        description: 'Detail of an earlier quilt.'
      }
    ]
  },
  {
    id: 'leaf-quilts',
    title: 'Leaf Quilts',
    image: '/assets/images/THUMBS/qButternutT.jpg',
    category: 'Bed Quilts',
    details: <div>
      On this page, I show you two quilts made with my (relatively new) leaf fabric. For more information about this particular technique, click here.
    </div>,
    variations: [
      {
        title: 'Butternut',
        image: '/assets/images/bedquilts/Butternut.jpg',
        description: <div>
          Above is Butternut, which is basically a setting of a very large piece of cloth which I made using some wonderful tree branches I came accross while out for a walk. The border fabric was made in the following manner:
          <br /><br />
          I took a piece of my ombre fabric, and rolled thickened black dye over maple leaves, resulting in a piece with colorful leaves peeking through the black. The whole process was made even more exciting by a sudden thunderstorm; I had to cover the piece-in-progress with plastic, and come back to it later!
        </div>
      },
      {
        title: "Butternut - detail",
        image: '/assets/images/bedquilts/ButternutDet1.jpg',
      },
      {
        title: "Sumac Diamonds",
        image: '/assets/images/bedquilts/Sumac.jpg',
        description: "A different approach, where I've used a piece of fabric which I made using Sumac leaves as the patterning resist. For the quilt, I cut my Sumac fabric into diamond shapes and separated them with a lattice and small diamonds."
      },
      {
        title: "Sumac Diamonds - detail",
        image: '/assets/images/bedquilts/SumacDetail.jpg',
      }
    ]
  },
  {
    id: 'zebra-ballet',
    title: 'Zebra Ballet',
    image: '/assets/images/THUMBS/qZebraBalletT.jpg',
    category: 'Bed Quilts',
    variations: [
      {
        title: 'Zebra Ballet',
        image: '/assets/images/bedquilts/ZebraBallet.jpg',
        description: <div>
          Above is an anomalous quilt; I couldn't possibly make it again even if I wanted to.
        Its tale is one of failure and fixing--
          <br /><br />
        I started out with the idea that I would mix 4 pieces of my ombre cloth (usually, I'm just trying to cope with two), and the result looked like a plaid blanket. Not my cup of tea! So I seperated the already-pieced quilt into units of 8x8 squares, put them at an odd slant, and broke them up with a turkey red cloth that I had on hand. The quilt still needed something, so I put a piece of striped cloth in the center of each unit, and I used an ombre/shibori I'd just made for the border.</div>,
      },
    ]
  },
  {
    id: 'pulcinella',
    title: 'Pulcinella',
    image: '/assets/images/bedquilts/Pulchinella.jpg',
    category: 'Bed Quilts',
    variations: [
      {
        title: 'Pulcinella',
        image: '/assets/images/bedquilts/Pulchinella.jpg',
        description: <div>
          The "background" of the center of the quilt on the right is made of squares cut from one large piece of (once again!) ombre fabric. The little colored squares marching around the border are sort of a pain to piece, but are so cheerful, I couldn't resist making them. 
        </div>
      },
    ]
  },
  {
    id: 'great-plains',
    title: 'Great Plains',
    image: '/assets/images/bedquilts/qBars.jpg',
    category: 'Bed Quilts',
    variations: [
      {
        title: 'Great Plains',
        image: '/assets/images/bedquilts/qBars.jpg'
      }
    ]
  },
  {
    id: 'crayola',
    title: 'Crayola',
    image: '/assets/images/bedquilts/qCrayola2T.jpg',
    category: 'Bed Quilts',
    details: <div>
      This is the second Crayola quilt I've made. It's so much fun!
      <br /><br />  
      I dyed a "fat quarter" (approx. 18" x 22") of each of about 40 colors, using a low-water immersion method in small plastic bags. This results in a wonderfully mottled fabric, several values of one color. An added bonus is that some of the dyes separate, giving me 2 or more colors in one fabric. The luscious colors seemed to cry out for a design that could show each color next to several others, in thin strips as well as larger blocks.
      <br /><br />
      I've used a "rubbing" technique for one of the borders, and recreated the same fabric for the quilt's backing.
    </div>,
    variations: [
      {
        title: 'Crayola',
        image: '/assets/images/bedquilts/qCrayola2.jpg'
      }
    ]
  },
  {
    id: 'jewel-boxes',
    title: 'Jewel Boxes',
    image: '/assets/images/bedquilts/QjewelBoxesT.jpg',
    category: 'Bed Quilts',
    details: <div>
      Jewel Boxes is a quiet, subtle quilt. There are shifts in the borders of each box, as well as in the lattice (which uses an ombre fabric). The insides of the boxes came from a single piece of breakdown screen printed fabric.
    </div>,
    variations: [
      {
        title: 'Jewel Boxes',
        image: '/assets/images/bedquilts/QjewelBoxes.jpg'
      }
    ]
  },
  {
    id: 'boogie',
    title: 'Boogie',
    image: '/assets/images/bedquilts/QBoogieT.jpg',
    category: 'Bed Quilts',
    details: <div>
      This is the second in the Boogie series. I'd intended, as with the first one, to have squares of striped piecing, but made a mistake in my cutting, and ended up with rectangles of stripes. Then I had to figure out a way to arrange them that worked. The result is even more rich and satisfying than the first of the series, Great Plains Boogie..
      <br /><br />
      The border fabric was produced in the fall, with the very last of the maple leaves which still clung to the trees!
    </div>,
    variations: [
      {
        title: 'Boogie',
        image: '/assets/images/bedquilts/QBoogie.jpg'
      },
      {
        title: 'Boogie - detail',
        image: '/assets/images/bedquilts/QBoogieDet.jpg'
      }
    ]
  },
  {
    id: 'square-in-square',
    title: 'Square In Square',
    image: '/assets/images/bedquilts/qSquare-in-SquareT.jpg',
    category: 'Bed Quilts',
    variations: [
      {
        image: '/assets/images/bedquilts/qSquare-in-Square.jpg'
      },
      {
        image: '/assets/images/bedquilts/QBinBdetail.jpg'
      }
    ]
  }

];

